var hr = function(r, e) {
  return hr = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, n) {
    t.__proto__ = n;
  } || function(t, n) {
    for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
  }, hr(r, e);
};
function tn(r, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  hr(r, e);
  function t() {
    this.constructor = r;
  }
  r.prototype = e === null ? Object.create(e) : (t.prototype = e.prototype, new t());
}
var p = function() {
  return p = Object.assign || function(e) {
    for (var t, n = 1, a = arguments.length; n < a; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, p.apply(this, arguments);
};
function ur(r, e) {
  var t = {};
  for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && e.indexOf(n) < 0 && (t[n] = r[n]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(r); a < n.length; a++)
      e.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(r, n[a]) && (t[n[a]] = r[n[a]]);
  return t;
}
function Zr(r, e) {
  var t = typeof Symbol == "function" && r[Symbol.iterator];
  if (!t) return r;
  var n = t.call(r), a, i = [], o;
  try {
    for (; (e === void 0 || e-- > 0) && !(a = n.next()).done; ) i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (t = n.return) && t.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}
function _r(r, e, t) {
  if (t || arguments.length === 2) for (var n = 0, a = e.length, i; n < a; n++)
    (i || !(n in e)) && (i || (i = Array.prototype.slice.call(e, 0, n)), i[n] = e[n]);
  return r.concat(i || Array.prototype.slice.call(e));
}
var $ = function() {
}, nn = function(r) {
  return r !== null && typeof r == "object" && r.getVelocity;
}, Kr = function(r, e) {
  return function(t) {
    return Math.max(Math.min(t, e), r);
  };
}, z = function(r) {
  return r % 1 ? Number(r.toFixed(5)) : r;
}, Z = /(-)?([\d]*\.?[\d])+/g, yr = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, De = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function K(r) {
  return typeof r == "string";
}
var Y = {
  test: function(r) {
    return typeof r == "number";
  },
  parse: parseFloat,
  transform: function(r) {
    return r;
  }
}, H = p(p({}, Y), { transform: Kr(0, 1) }), rr = p(p({}, Y), { default: 1 }), G = function(r) {
  return {
    test: function(e) {
      return K(e) && e.endsWith(r) && e.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function(e) {
      return "" + e + r;
    }
  };
}, V = G("deg"), W = G("%"), c = G("px"), an = G("vh"), on = G("vw"), Nr = p(p({}, W), { parse: function(r) {
  return W.parse(r) / 100;
}, transform: function(r) {
  return W.transform(r * 100);
} }), Cr = function(r, e) {
  return function(t) {
    return !!(K(t) && De.test(t) && t.startsWith(r) || e && Object.prototype.hasOwnProperty.call(t, e));
  };
}, Yr = function(r, e, t) {
  return function(n) {
    var a;
    if (!K(n))
      return n;
    var i = n.match(Z), o = i[0], s = i[1], f = i[2], u = i[3];
    return a = {}, a[r] = parseFloat(o), a[e] = parseFloat(s), a[t] = parseFloat(f), a.alpha = u !== void 0 ? parseFloat(u) : 1, a;
  };
}, j = {
  test: Cr("hsl", "hue"),
  parse: Yr("hue", "saturation", "lightness"),
  transform: function(r) {
    var e = r.hue, t = r.saturation, n = r.lightness, a = r.alpha, i = a === void 0 ? 1 : a;
    return "hsla(" + Math.round(e) + ", " + W.transform(z(t)) + ", " + W.transform(z(n)) + ", " + z(H.transform(i)) + ")";
  }
}, we = Kr(0, 255), pr = p(p({}, Y), { transform: function(r) {
  return Math.round(we(r));
} }), L = {
  test: Cr("rgb", "red"),
  parse: Yr("red", "green", "blue"),
  transform: function(r) {
    var e = r.red, t = r.green, n = r.blue, a = r.alpha, i = a === void 0 ? 1 : a;
    return "rgba(" + pr.transform(e) + ", " + pr.transform(t) + ", " + pr.transform(n) + ", " + z(H.transform(i)) + ")";
  }
};
function Re(r) {
  var e = "", t = "", n = "", a = "";
  return r.length > 5 ? (e = r.substr(1, 2), t = r.substr(3, 2), n = r.substr(5, 2), a = r.substr(7, 2)) : (e = r.substr(1, 1), t = r.substr(2, 1), n = r.substr(3, 1), a = r.substr(4, 1), e += e, t += t, n += n, a += a), {
    red: parseInt(e, 16),
    green: parseInt(t, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var gr = {
  test: Cr("#"),
  parse: Re,
  transform: L.transform
}, R = {
  test: function(r) {
    return L.test(r) || gr.test(r) || j.test(r);
  },
  parse: function(r) {
    return L.test(r) ? L.parse(r) : j.test(r) ? j.parse(r) : gr.parse(r);
  },
  transform: function(r) {
    return K(r) ? r : r.hasOwnProperty("red") ? L.transform(r) : j.transform(r);
  }
}, Gr = "${c}", Jr = "${n}";
function Ie(r) {
  var e, t, n, a;
  return isNaN(r) && K(r) && ((t = (e = r.match(Z)) === null || e === void 0 ? void 0 : e.length) !== null && t !== void 0 ? t : 0) + ((a = (n = r.match(yr)) === null || n === void 0 ? void 0 : n.length) !== null && a !== void 0 ? a : 0) > 0;
}
function Qr(r) {
  var e = [], t = 0, n = r.match(yr);
  n && (t = n.length, r = r.replace(yr, Gr), e.push.apply(e, n.map(R.parse)));
  var a = r.match(Z);
  return a && (r = r.replace(Z, Jr), e.push.apply(e, a.map(Y.parse))), { values: e, numColors: t, tokenised: r };
}
function qr(r) {
  return Qr(r).values;
}
function Xr(r) {
  var e = Qr(r), t = e.values, n = e.numColors, a = e.tokenised, i = t.length;
  return function(o) {
    for (var s = a, f = 0; f < i; f++)
      s = s.replace(f < n ? Gr : Jr, f < n ? R.transform(o[f]) : z(o[f]));
    return s;
  };
}
var Ee = function(r) {
  return typeof r == "number" ? 0 : r;
};
function Ne(r) {
  var e = qr(r), t = Xr(r);
  return t(e.map(Ee));
}
var J = { test: Ie, parse: qr, createTransformer: Xr, getAnimatableNone: Ne }, Ve = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function Fe(r) {
  var e = r.slice(0, -1).split("("), t = e[0], n = e[1];
  if (t === "drop-shadow")
    return r;
  var a = (n.match(Z) || [])[0];
  if (!a)
    return r;
  var i = n.replace(a, ""), o = Ve.has(t) ? 1 : 0;
  return a !== n && (o *= 100), t + "(" + o + i + ")";
}
var Ue = /([a-z-]*)\(.*?\)/g, br = p(p({}, J), { getAnimatableNone: function(r) {
  var e = r.match(Ue);
  return e ? e.map(Fe).join(" ") : r;
} }), Vr = p(p({}, Y), { transform: Math.round }), je = {
  // Border props
  borderWidth: c,
  borderTopWidth: c,
  borderRightWidth: c,
  borderBottomWidth: c,
  borderLeftWidth: c,
  borderRadius: c,
  radius: c,
  borderTopLeftRadius: c,
  borderTopRightRadius: c,
  borderBottomRightRadius: c,
  borderBottomLeftRadius: c,
  // Positioning props
  width: c,
  maxWidth: c,
  height: c,
  maxHeight: c,
  size: c,
  top: c,
  right: c,
  bottom: c,
  left: c,
  // Spacing props
  padding: c,
  paddingTop: c,
  paddingRight: c,
  paddingBottom: c,
  paddingLeft: c,
  margin: c,
  marginTop: c,
  marginRight: c,
  marginBottom: c,
  marginLeft: c,
  // Transform props
  rotate: V,
  rotateX: V,
  rotateY: V,
  rotateZ: V,
  scale: rr,
  scaleX: rr,
  scaleY: rr,
  scaleZ: rr,
  skew: V,
  skewX: V,
  skewY: V,
  distance: c,
  translateX: c,
  translateY: c,
  translateZ: c,
  x: c,
  y: c,
  z: c,
  perspective: c,
  transformPerspective: c,
  opacity: H,
  originX: Nr,
  originY: Nr,
  originZ: c,
  // Misc
  zIndex: Vr,
  // SVG
  fillOpacity: H,
  strokeOpacity: H,
  numOctaves: Vr
}, Le = function(r) {
  return Array.isArray(r);
}, xr = function(r, e, t) {
  return Math.min(Math.max(t, r), e);
}, vr = 1e-3, Pe = 0.01, ke = 10, Be = 0.05, ze = 1;
function He(r) {
  var e = r.duration, t = e === void 0 ? 800 : e, n = r.bounce, a = n === void 0 ? 0.25 : n, i = r.velocity, o = i === void 0 ? 0 : i, s = r.mass, f = s === void 0 ? 1 : s, u, l, v = 1 - a;
  v = xr(Be, ze, v), t = xr(Pe, ke, t / 1e3), v < 1 ? (u = function(y) {
    var M = y * v, g = M * t, E = M - o, I = Sr(y, v), T = Math.exp(-g);
    return vr - E / I * T;
  }, l = function(y) {
    var M = y * v, g = M * t, E = g * o + o, I = Math.pow(v, 2) * Math.pow(y, 2) * t, T = Math.exp(-g), h = Sr(Math.pow(y, 2), v), b = -u(y) + vr > 0 ? -1 : 1;
    return b * ((E - I) * T) / h;
  }) : (u = function(y) {
    var M = Math.exp(-y * t), g = (y - o) * t + 1;
    return -vr + M * g;
  }, l = function(y) {
    var M = Math.exp(-y * t), g = (o - y) * (t * t);
    return M * g;
  });
  var m = 5 / t, d = $e(u, l, m);
  if (t = t * 1e3, isNaN(d))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  var S = Math.pow(d, 2) * f;
  return {
    stiffness: S,
    damping: v * 2 * Math.sqrt(f * S),
    duration: t
  };
}
var We = 12;
function $e(r, e, t) {
  for (var n = t, a = 1; a < We; a++)
    n = n - r(n) / e(n);
  return n;
}
function Sr(r, e) {
  return r * Math.sqrt(1 - e * e);
}
var Ze = ["duration", "bounce"], _e = ["stiffness", "damping", "mass"];
function Fr(r, e) {
  return e.some(function(t) {
    return r[t] !== void 0;
  });
}
function Ke(r) {
  var e = p({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, r);
  if (!Fr(r, _e) && Fr(r, Ze)) {
    var t = He(r);
    e = p(p(p({}, e), t), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function Dr(r) {
  var e = r.from, t = e === void 0 ? 0 : e, n = r.to, a = n === void 0 ? 1 : n, i = r.restSpeed, o = i === void 0 ? 2 : i, s = r.restDelta, f = ur(r, ["from", "to", "restSpeed", "restDelta"]), u = { done: !1, value: t }, l = Ke(f), v = l.stiffness, m = l.damping, d = l.mass, S = l.velocity, y = l.duration, M = l.isResolvedFromDuration, g = Ur, E = Ur;
  function I() {
    var T = S ? -(S / 1e3) : 0, h = a - t, b = m / (2 * Math.sqrt(v * d)), O = Math.sqrt(v / d) / 1e3;
    if (s ?? (s = Math.abs(a - t) <= 1 ? 0.01 : 0.4), b < 1) {
      var A = Sr(O, b);
      g = function(x) {
        var D = Math.exp(-b * O * x);
        return a - D * ((T + b * O * h) / A * Math.sin(A * x) + h * Math.cos(A * x));
      }, E = function(x) {
        var D = Math.exp(-b * O * x);
        return b * O * D * (Math.sin(A * x) * (T + b * O * h) / A + h * Math.cos(A * x)) - D * (Math.cos(A * x) * (T + b * O * h) - A * h * Math.sin(A * x));
      };
    } else if (b === 1)
      g = function(x) {
        return a - Math.exp(-O * x) * (h + (T + O * h) * x);
      };
    else {
      var w = O * Math.sqrt(b * b - 1);
      g = function(x) {
        var D = Math.exp(-b * O * x), N = Math.min(w * x, 300);
        return a - D * ((T + b * O * h) * Math.sinh(N) + w * h * Math.cosh(N)) / w;
      };
    }
  }
  return I(), {
    next: function(T) {
      var h = g(T);
      if (M)
        u.done = T >= y;
      else {
        var b = E(T) * 1e3, O = Math.abs(b) <= o, A = Math.abs(a - h) <= s;
        u.done = O && A;
      }
      return u.value = u.done ? a : h, u;
    },
    flipTarget: function() {
      var T;
      S = -S, T = [a, t], t = T[0], a = T[1], I();
    }
  };
}
Dr.needsInterpolation = function(r, e) {
  return typeof r == "string" || typeof e == "string";
};
var Ur = function(r) {
  return 0;
}, re = function(r, e, t) {
  var n = e - r;
  return n === 0 ? 1 : (t - r) / n;
}, or = function(r, e, t) {
  return -t * r + t * e + r;
}, Ye = function(r, e, t) {
  var n = r * r, a = e * e;
  return Math.sqrt(Math.max(0, t * (a - n) + n));
}, Ge = [gr, L, j], jr = function(r) {
  return Ge.find(function(e) {
    return e.test(r);
  });
}, ee = function(r, e) {
  var t = jr(r), n = jr(e);
  $(t.transform === n.transform);
  var a = t.parse(r), i = n.parse(e), o = p({}, a), s = t === j ? or : Ye;
  return function(f) {
    for (var u in o)
      u !== "alpha" && (o[u] = s(a[u], i[u], f));
    return o.alpha = or(a.alpha, i.alpha, f), t.transform(o);
  };
}, Je = function(r) {
  return typeof r == "number";
}, Qe = function(r, e) {
  return function(t) {
    return e(r(t));
  };
}, te = function() {
  for (var r = [], e = 0; e < arguments.length; e++)
    r[e] = arguments[e];
  return r.reduce(Qe);
};
function ne(r, e) {
  return Je(r) ? function(t) {
    return or(r, e, t);
  } : R.test(r) ? ee(r, e) : oe(r, e);
}
var ae = function(r, e) {
  var t = _r([], r), n = t.length, a = r.map(function(i, o) {
    return ne(i, e[o]);
  });
  return function(i) {
    for (var o = 0; o < n; o++)
      t[o] = a[o](i);
    return t;
  };
}, qe = function(r, e) {
  var t = p(p({}, r), e), n = {};
  for (var a in t)
    r[a] !== void 0 && e[a] !== void 0 && (n[a] = ne(r[a], e[a]));
  return function(i) {
    for (var o in n)
      t[o] = n[o](i);
    return t;
  };
};
function Lr(r) {
  for (var e = J.parse(r), t = e.length, n = 0, a = 0, i = 0, o = 0; o < t; o++)
    n || typeof e[o] == "number" ? n++ : e[o].hue !== void 0 ? i++ : a++;
  return { parsed: e, numNumbers: n, numRGB: a, numHSL: i };
}
var oe = function(r, e) {
  var t = J.createTransformer(e), n = Lr(r), a = Lr(e);
  return te(ae(n.parsed, a.parsed), t);
}, Xe = function(r, e) {
  return function(t) {
    return or(r, e, t);
  };
};
function rt(r) {
  if (typeof r == "number")
    return Xe;
  if (typeof r == "string")
    return R.test(r) ? ee : oe;
  if (Array.isArray(r))
    return ae;
  if (typeof r == "object")
    return qe;
}
function et(r, e, t) {
  for (var n = [], a = t || rt(r[0]), i = r.length - 1, o = 0; o < i; o++) {
    var s = a(r[o], r[o + 1]);
    if (e) {
      var f = Array.isArray(e) ? e[o] : e;
      s = te(f, s);
    }
    n.push(s);
  }
  return n;
}
function tt(r, e) {
  var t = r[0], n = r[1], a = e[0];
  return function(i) {
    return a(re(t, n, i));
  };
}
function nt(r, e) {
  var t = r.length, n = t - 1;
  return function(a) {
    var i = 0, o = !1;
    if (a <= r[0] ? o = !0 : a >= r[n] && (i = n - 1, o = !0), !o) {
      for (var s = 1; s < t && !(r[s] > a || s === n); s++)
        ;
      i = s - 1;
    }
    var f = re(r[i], r[i + 1], a);
    return e[i](f);
  };
}
function ie(r, e, t) {
  var n = t === void 0 ? {} : t, a = n.clamp, i = a === void 0 ? !0 : a, o = n.ease, s = n.mixer, f = r.length;
  $(f === e.length), $(!o || !Array.isArray(o) || o.length === f - 1), r[0] > r[f - 1] && (r = [].concat(r), e = [].concat(e), r.reverse(), e.reverse());
  var u = et(e, o, s), l = f === 2 ? tt(r, u) : nt(r, u);
  return i ? function(v) {
    return l(xr(r[0], r[f - 1], v));
  } : l;
}
var fr = function(r) {
  return function(e) {
    return 1 - r(1 - e);
  };
}, wr = function(r) {
  return function(e) {
    return e <= 0.5 ? r(2 * e) / 2 : (2 - r(2 * (1 - e))) / 2;
  };
}, at = function(r) {
  return function(e) {
    return Math.pow(e, r);
  };
}, se = function(r) {
  return function(e) {
    return e * e * ((r + 1) * e - r);
  };
}, ot = function(r) {
  var e = se(r);
  return function(t) {
    return (t *= 2) < 1 ? 0.5 * e(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1)));
  };
}, ue = 1.525, it = 4 / 11, st = 8 / 11, ut = 9 / 10, fe = function(r) {
  return r;
}, Rr = at(2), ft = fr(Rr), ce = wr(Rr), le = function(r) {
  return 1 - Math.sin(Math.acos(r));
}, pe = fr(le), ct = wr(pe), Ir = se(ue), lt = fr(Ir), pt = wr(Ir), vt = ot(ue), dt = 4356 / 361, mt = 35442 / 1805, ht = 16061 / 1805, ir = function(r) {
  if (r === 1 || r === 0)
    return r;
  var e = r * r;
  return r < it ? 7.5625 * e : r < st ? 9.075 * e - 9.9 * r + 3.4 : r < ut ? dt * e - mt * r + ht : 10.8 * r * r - 20.52 * r + 10.72;
}, yt = fr(ir), gt = function(r) {
  return r < 0.5 ? 0.5 * (1 - ir(1 - r * 2)) : 0.5 * ir(r * 2 - 1) + 0.5;
};
function bt(r, e) {
  return r.map(function() {
    return e || ce;
  }).splice(0, r.length - 1);
}
function xt(r) {
  var e = r.length;
  return r.map(function(t, n) {
    return n !== 0 ? n / (e - 1) : 0;
  });
}
function St(r, e) {
  return r.map(function(t) {
    return t * e;
  });
}
function nr(r) {
  var e = r.from, t = e === void 0 ? 0 : e, n = r.to, a = n === void 0 ? 1 : n, i = r.ease, o = r.offset, s = r.duration, f = s === void 0 ? 300 : s, u = { done: !1, value: t }, l = Array.isArray(a) ? a : [t, a], v = St(o && o.length === l.length ? o : xt(l), f);
  function m() {
    return ie(v, l, {
      ease: Array.isArray(i) ? i : bt(l, i)
    });
  }
  var d = m();
  return {
    next: function(S) {
      return u.value = d(S), u.done = S >= f, u;
    },
    flipTarget: function() {
      l.reverse(), d = m();
    }
  };
}
function Tt(r) {
  var e = r.velocity, t = e === void 0 ? 0 : e, n = r.from, a = n === void 0 ? 0 : n, i = r.power, o = i === void 0 ? 0.8 : i, s = r.timeConstant, f = s === void 0 ? 350 : s, u = r.restDelta, l = u === void 0 ? 0.5 : u, v = r.modifyTarget, m = { done: !1, value: a }, d = o * t, S = a + d, y = v === void 0 ? S : v(S);
  return y !== S && (d = y - a), {
    next: function(M) {
      var g = -d * Math.exp(-M / f);
      return m.done = !(g > l || g < -l), m.value = m.done ? y : y + g, m;
    },
    flipTarget: function() {
    }
  };
}
var Pr = { keyframes: nr, spring: Dr, decay: Tt };
function Ot(r) {
  if (Array.isArray(r.to))
    return nr;
  if (Pr[r.type])
    return Pr[r.type];
  var e = new Set(Object.keys(r));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? nr : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? Dr : nr;
}
var ve = 1 / 60 * 1e3, Mt = typeof performance < "u" ? function() {
  return performance.now();
} : function() {
  return Date.now();
}, de = typeof window < "u" ? function(r) {
  return window.requestAnimationFrame(r);
} : function(r) {
  return setTimeout(function() {
    return r(Mt());
  }, ve);
};
function At(r) {
  var e = [], t = [], n = 0, a = !1, i = /* @__PURE__ */ new WeakSet(), o = {
    schedule: function(s, f, u) {
      f === void 0 && (f = !1), u === void 0 && (u = !1);
      var l = u && a, v = l ? e : t;
      return f && i.add(s), v.indexOf(s) === -1 && (v.push(s), l && a && (n = e.length)), s;
    },
    cancel: function(s) {
      var f = t.indexOf(s);
      f !== -1 && t.splice(f, 1), i.delete(s);
    },
    process: function(s) {
      var f;
      if (a = !0, f = [t, e], e = f[0], t = f[1], t.length = 0, n = e.length, n)
        for (var u = 0; u < n; u++) {
          var l = e[u];
          l(s), i.has(l) && (o.schedule(l), r());
        }
      a = !1;
    }
  };
  return o;
}
var Ct = 40, Tr = !0, _ = !1, Or = !1, P = {
  delta: 0,
  timestamp: 0
}, Q = ["read", "update", "preRender", "render", "postRender"], cr = /* @__PURE__ */ Q.reduce(function(r, e) {
  return r[e] = At(function() {
    return _ = !0;
  }), r;
}, {}), Mr = /* @__PURE__ */ Q.reduce(function(r, e) {
  var t = cr[e];
  return r[e] = function(n, a, i) {
    return a === void 0 && (a = !1), i === void 0 && (i = !1), _ || Rt(), t.schedule(n, a, i);
  }, r;
}, {}), Dt = /* @__PURE__ */ Q.reduce(function(r, e) {
  return r[e] = cr[e].cancel, r;
}, {}), sn = /* @__PURE__ */ Q.reduce(function(r, e) {
  return r[e] = function() {
    return cr[e].process(P);
  }, r;
}, {}), wt = function(r) {
  return cr[r].process(P);
}, me = function(r) {
  _ = !1, P.delta = Tr ? ve : Math.max(Math.min(r - P.timestamp, Ct), 1), P.timestamp = r, Or = !0, Q.forEach(wt), Or = !1, _ && (Tr = !1, de(me));
}, Rt = function() {
  _ = !0, Tr = !0, Or || de(me);
}, he = function() {
  return P;
};
function ye(r, e, t) {
  return t === void 0 && (t = 0), r - e - t;
}
function It(r, e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = !0), n ? ye(e + -r, e, t) : e - (r - e) + t;
}
function Et(r, e, t, n) {
  return n ? r >= e + t : r <= -t;
}
var Nt = function(r) {
  var e = function(t) {
    var n = t.delta;
    return r(n);
  };
  return {
    start: function() {
      return Mr.update(e, !0);
    },
    stop: function() {
      return Dt.update(e);
    }
  };
};
function ge(r) {
  var e, t, n = r.from, a = r.autoplay, i = a === void 0 ? !0 : a, o = r.driver, s = o === void 0 ? Nt : o, f = r.elapsed, u = f === void 0 ? 0 : f, l = r.repeat, v = l === void 0 ? 0 : l, m = r.repeatType, d = m === void 0 ? "loop" : m, S = r.repeatDelay, y = S === void 0 ? 0 : S, M = r.onPlay, g = r.onStop, E = r.onComplete, I = r.onRepeat, T = r.onUpdate, h = ur(r, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]), b = h.to, O, A = 0, w = h.duration, x, D = !1, N = !0, U, k = Ot(h);
  !((t = (e = k).needsInterpolation) === null || t === void 0) && t.call(e, n, b) && (U = ie([0, 100], [n, b], {
    clamp: !1
  }), n = 0, b = 100);
  var q = k(p(p({}, h), { from: n, to: b }));
  function C() {
    A++, d === "reverse" ? (N = A % 2 === 0, u = It(u, w, y, N)) : (u = ye(u, w, y), d === "mirror" && q.flipTarget()), D = !1, I && I();
  }
  function X() {
    O.stop(), E && E();
  }
  function B(lr) {
    if (N || (lr = -lr), u += lr, !D) {
      var Er = q.next(Math.max(0, u));
      x = Er.value, U && (x = U(x)), D = N ? Er.done : u <= 0;
    }
    T == null || T(x), D && (A === 0 && (w ?? (w = u)), A < v ? Et(u, w, y, N) && C() : X());
  }
  function Ce() {
    M == null || M(), O = s(B), O.start();
  }
  return i && Ce(), {
    stop: function() {
      g == null || g(), O.stop();
    }
  };
}
function be(r, e) {
  return e ? r * (1e3 / e) : 0;
}
function Vt(r) {
  var e = r.from, t = e === void 0 ? 0 : e, n = r.velocity, a = n === void 0 ? 0 : n, i = r.min, o = r.max, s = r.power, f = s === void 0 ? 0.8 : s, u = r.timeConstant, l = u === void 0 ? 750 : u, v = r.bounceStiffness, m = v === void 0 ? 500 : v, d = r.bounceDamping, S = d === void 0 ? 10 : d, y = r.restDelta, M = y === void 0 ? 1 : y, g = r.modifyTarget, E = r.driver, I = r.onUpdate, T = r.onComplete, h;
  function b(C) {
    return i !== void 0 && C < i || o !== void 0 && C > o;
  }
  function O(C) {
    return i === void 0 ? o : o === void 0 || Math.abs(i - C) < Math.abs(o - C) ? i : o;
  }
  function A(C) {
    h == null || h.stop(), h = ge(p(p({}, C), { driver: E, onUpdate: function(X) {
      var B;
      I == null || I(X), (B = C.onUpdate) === null || B === void 0 || B.call(C, X);
    }, onComplete: T }));
  }
  function w(C) {
    A(p({ type: "spring", stiffness: m, damping: S, restDelta: M }, C));
  }
  if (b(t))
    w({ from: t, velocity: a, to: O(t) });
  else {
    var x = f * a + t;
    typeof g < "u" && (x = g(x));
    var D = O(x), N = D === i ? -1 : 1, U, k, q = function(C) {
      U = k, k = C, a = be(C - U, he().delta), (N === 1 && C > D || N === -1 && C < D) && w({ from: C, to: D, velocity: a });
    };
    A({
      type: "decay",
      from: t,
      velocity: a,
      timeConstant: l,
      power: f,
      restDelta: M,
      modifyTarget: g,
      onUpdate: b(x) ? q : void 0
    });
  }
  return {
    stop: function() {
      return h == null ? void 0 : h.stop();
    }
  };
}
var xe = function(r, e) {
  return 1 - 3 * e + 3 * r;
}, Se = function(r, e) {
  return 3 * e - 6 * r;
}, Te = function(r) {
  return 3 * r;
}, sr = function(r, e, t) {
  return ((xe(e, t) * r + Se(e, t)) * r + Te(e)) * r;
}, Oe = function(r, e, t) {
  return 3 * xe(e, t) * r * r + 2 * Se(e, t) * r + Te(e);
}, Ft = 1e-7, Ut = 10;
function jt(r, e, t, n, a) {
  var i, o, s = 0;
  do
    o = e + (t - e) / 2, i = sr(o, n, a) - r, i > 0 ? t = o : e = o;
  while (Math.abs(i) > Ft && ++s < Ut);
  return o;
}
var Lt = 8, Pt = 1e-3;
function kt(r, e, t, n) {
  for (var a = 0; a < Lt; ++a) {
    var i = Oe(e, t, n);
    if (i === 0)
      return e;
    var o = sr(e, t, n) - r;
    e -= o / i;
  }
  return e;
}
var ar = 11, er = 1 / (ar - 1);
function Bt(r, e, t, n) {
  if (r === e && t === n)
    return fe;
  for (var a = new Float32Array(ar), i = 0; i < ar; ++i)
    a[i] = sr(i * er, r, t);
  function o(s) {
    for (var f = 0, u = 1, l = ar - 1; u !== l && a[u] <= s; ++u)
      f += er;
    --u;
    var v = (s - a[u]) / (a[u + 1] - a[u]), m = f + v * er, d = Oe(m, r, t);
    return d >= Pt ? kt(s, m, r, t) : d === 0 ? m : jt(s, f, f + er, r, t);
  }
  return function(s) {
    return s === 0 || s === 1 ? s : sr(o(s), e, n);
  };
}
var Ar = function(r) {
  return r * 1e3;
}, kr = {
  linear: fe,
  easeIn: Rr,
  easeInOut: ce,
  easeOut: ft,
  circIn: le,
  circInOut: ct,
  circOut: pe,
  backIn: Ir,
  backInOut: pt,
  backOut: lt,
  anticipate: vt,
  bounceIn: yt,
  bounceInOut: gt,
  bounceOut: ir
}, Br = function(r) {
  if (Array.isArray(r)) {
    $(r.length === 4);
    var e = Zr(r, 4), t = e[0], n = e[1], a = e[2], i = e[3];
    return Bt(t, n, a, i);
  } else if (typeof r == "string")
    return $(kr[r] !== void 0), kr[r];
  return r;
}, zt = function(r) {
  return Array.isArray(r) && typeof r[0] != "number";
}, zr = function(r, e) {
  return r === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  J.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, F = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  };
}, tr = function(r) {
  return {
    type: "spring",
    stiffness: 550,
    damping: r === 0 ? 2 * Math.sqrt(550) : 30,
    restDelta: 0.01,
    restSpeed: 10
  };
}, dr = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, Ht = function(r) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: r
  };
}, Hr = {
  x: F,
  y: F,
  z: F,
  rotate: F,
  rotateX: F,
  rotateY: F,
  rotateZ: F,
  scaleX: tr,
  scaleY: tr,
  scale: tr,
  opacity: dr,
  backgroundColor: dr,
  color: dr,
  default: tr
}, Wt = function(r, e) {
  var t;
  return Le(e) ? t = Ht : t = Hr[r] || Hr.default, p({ to: e }, t(e));
}, $t = p(p({}, je), {
  // Color props
  color: R,
  backgroundColor: R,
  outlineColor: R,
  fill: R,
  stroke: R,
  // Border props
  borderColor: R,
  borderTopColor: R,
  borderRightColor: R,
  borderBottomColor: R,
  borderLeftColor: R,
  filter: br,
  WebkitFilter: br
}), Zt = function(r) {
  return $t[r];
};
function Me(r, e) {
  var t, n = Zt(r);
  return n !== br && (n = J), (t = n.getAnimatableNone) === null || t === void 0 ? void 0 : t.call(n, e);
}
function _t(r) {
  r.when, r.delay, r.delayChildren, r.staggerChildren, r.staggerDirection, r.repeat, r.repeatType, r.repeatDelay, r.from;
  var e = ur(r, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
function Kt(r) {
  var e = r.ease, t = r.times, n = r.yoyo, a = r.flip, i = r.loop, o = ur(r, ["ease", "times", "yoyo", "flip", "loop"]), s = p({}, o);
  return t && (s.offset = t), o.duration && (s.duration = Ar(o.duration)), o.repeatDelay && (s.repeatDelay = Ar(o.repeatDelay)), e && (s.ease = zt(e) ? e.map(Br) : Br(e)), o.type === "tween" && (s.type = "keyframes"), (n || i || a) && (n ? s.repeatType = "reverse" : i ? s.repeatType = "loop" : a && (s.repeatType = "mirror"), s.repeat = i || n || a || o.repeat), o.type !== "spring" && (s.type = "keyframes"), s;
}
function Yt(r, e) {
  var t, n = Ae(r, e) || {};
  return (t = n.delay) !== null && t !== void 0 ? t : 0;
}
function Gt(r) {
  return Array.isArray(r.to) && r.to[0] === null && (r.to = _r([], Zr(r.to)), r.to[0] = r.from), r;
}
function Jt(r, e, t) {
  var n;
  return Array.isArray(e.to) && ((n = r.duration) !== null && n !== void 0 || (r.duration = 0.8)), Gt(e), _t(r) || (r = p(p({}, r), Wt(t, e.to))), p(p({}, e), Kt(r));
}
function Qt(r, e, t, n, a) {
  var i, o = Ae(n, r), s = (i = o.from) !== null && i !== void 0 ? i : e.get(), f = zr(r, t);
  s === "none" && f && typeof t == "string" ? s = Me(r, t) : Wr(s) && typeof t == "string" ? s = $r(t) : !Array.isArray(t) && Wr(t) && typeof s == "string" && (t = $r(s));
  var u = zr(r, s);
  function l() {
    var m = {
      from: s,
      to: t,
      velocity: e.getVelocity(),
      onComplete: a,
      onUpdate: function(d) {
        return e.set(d);
      }
    };
    return o.type === "inertia" || o.type === "decay" ? Vt(p(p({}, m), o)) : ge(p(p({}, Jt(o, m, r)), { onUpdate: function(d) {
      var S;
      m.onUpdate(d), (S = o.onUpdate) === null || S === void 0 || S.call(o, d);
    }, onComplete: function() {
      var d;
      m.onComplete(), (d = o.onComplete) === null || d === void 0 || d.call(o);
    } }));
  }
  function v() {
    var m;
    return e.set(t), a(), (m = o == null ? void 0 : o.onComplete) === null || m === void 0 || m.call(o), { stop: function() {
    } };
  }
  return !u || !f || o.type === !1 ? v : l;
}
function Wr(r) {
  return r === 0 || typeof r == "string" && parseFloat(r) === 0 && r.indexOf(" ") === -1;
}
function $r(r) {
  return typeof r == "number" ? 0 : Me("", r);
}
function Ae(r, e) {
  return r[e] || r.default || r;
}
function un(r, e, t, n) {
  return n === void 0 && (n = {}), e.start(function(a) {
    var i, o, s = Qt(r, e, t, n, a), f = Yt(n, r), u = function() {
      return o = s();
    };
    return f ? i = setTimeout(u, Ar(f)) : u(), function() {
      clearTimeout(i), o == null || o.stop();
    };
  });
}
function qt(r, e) {
  r.indexOf(e) === -1 && r.push(e);
}
function Xt(r, e) {
  var t = r.indexOf(e);
  t > -1 && r.splice(t, 1);
}
var mr = (
  /** @class */
  function() {
    function r() {
      this.subscriptions = [];
    }
    return r.prototype.add = function(e) {
      var t = this;
      return qt(this.subscriptions, e), function() {
        return Xt(t.subscriptions, e);
      };
    }, r.prototype.notify = function(e, t, n) {
      var a = this.subscriptions.length;
      if (a)
        if (a === 1)
          this.subscriptions[0](e, t, n);
        else
          for (var i = 0; i < a; i++) {
            var o = this.subscriptions[i];
            o && o(e, t, n);
          }
    }, r.prototype.getSize = function() {
      return this.subscriptions.length;
    }, r.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, r;
  }()
), rn = function(r) {
  return !isNaN(parseFloat(r));
}, en = (
  /** @class */
  function() {
    function r(e) {
      var t = this;
      this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new mr(), this.velocityUpdateSubscribers = new mr(), this.renderSubscribers = new mr(), this.canTrackVelocity = !1, this.updateAndNotify = function(n, a) {
        a === void 0 && (a = !0), t.prev = t.current, t.current = n;
        var i = he(), o = i.delta, s = i.timestamp;
        t.lastUpdated !== s && (t.timeDelta = o, t.lastUpdated = s, Mr.postRender(t.scheduleVelocityCheck)), t.prev !== t.current && t.updateSubscribers.notify(t.current), t.velocityUpdateSubscribers.getSize() && t.velocityUpdateSubscribers.notify(t.getVelocity()), a && t.renderSubscribers.notify(t.current);
      }, this.scheduleVelocityCheck = function() {
        return Mr.postRender(t.velocityCheck);
      }, this.velocityCheck = function(n) {
        var a = n.timestamp;
        a !== t.lastUpdated && (t.prev = t.current, t.velocityUpdateSubscribers.notify(t.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = rn(this.current);
    }
    return r.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, r.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, r.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, r.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, r.prototype.set = function(e, t) {
      t === void 0 && (t = !0), !t || !this.passiveEffect ? this.updateAndNotify(e, t) : this.passiveEffect(e, this.updateAndNotify);
    }, r.prototype.get = function() {
      return this.current;
    }, r.prototype.getPrevious = function() {
      return this.prev;
    }, r.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        be(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, r.prototype.start = function(e) {
      var t = this;
      return this.stop(), new Promise(function(n) {
        t.hasAnimated = !0, t.stopAnimation = e(n);
      }).then(function() {
        return t.clearAnimation();
      });
    }, r.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, r.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, r.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, r.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, r;
  }()
);
function fn(r) {
  return new en(r);
}
export {
  sn as A,
  tn as B,
  Ae as C,
  qt as D,
  Xt as E,
  $ as F,
  Zt as G,
  ie as H,
  mr as S,
  Zr as _,
  _r as a,
  p as b,
  ur as c,
  Le as d,
  Je as e,
  te as f,
  Y as g,
  W as h,
  nn as i,
  V as j,
  an as k,
  R as l,
  fn as m,
  je as n,
  J as o,
  c as p,
  Me as q,
  he as r,
  un as s,
  Mr as t,
  Dt as u,
  on as v,
  Ar as w,
  or as x,
  re as y,
  xr as z
};
//# sourceMappingURL=index-DpjUVRH2.mjs.map
